import React, { useEffect, useState } from "react";
import ContactContent from "./ContactContent"; // ✅ FIXED default import

export const Contact = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const currentDate = now.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const currentTime = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <div>
      {/* Contact section */}
      <div id="contact" className="contact">
        <div className="contact-writeup">
          <p className="contact-heading">Let's Connect.</p>
          <ContactContent />
        </div>
      </div>

      {/* Footer / End Page */}
      <div className="end-page">
        {/* Instagram */}
        <div className="column">
          <p className="contact-heading" style={{ textAlign: "center" }}>
            <a
              href="https://www.instagram.com/mrcaption49"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "white",
                fontFamily: "Poppins, sans-serif",
                fontSize: "20px",
              }}
            >
              <i
                className="fa-brands fa-instagram"
                style={{ marginRight: "8px" }}
              ></i>
              Instagram -{" "}
              <span style={{ color: "#FFC107" }}>@mrcaption49</span>
            </a>
          </p>
        </div>

        {/* LinkedIn */}
        <div className="column">
          <p className="contact-heading" style={{ textAlign: "center" }}>
            <a
              href="https://www.linkedin.com/in/pranavbakare49/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "white",
                fontFamily: "Poppins, sans-serif",
                fontSize: "20px",
              }}
            >
              <i
                className="fa-brands fa-linkedin"
                style={{ marginRight: "8px" }}
              ></i>
              LinkedIn -{" "}
              <span style={{ color: "#FFC107" }}>pranavbakare49</span>
            </a>
          </p>
        </div>

        {/* Last Updated */}
        <div className="column">
          <p
            className="contact-heading"
            style={{
              textAlign: "center",
              fontFamily: "Poppins, sans-serif",
              fontSize: "20px",
              color: "white",
            }}
          >
            🗓️ Current Timestamp -{" "}
            <span style={{ color: "#FFC107" }}>
              {currentDate} at {currentTime}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
